<template>

    <FloatingPanel>

        <div class="canvas-blocks-sky-headerCharlie-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">
                <div slot="Algemeen">

                    <SwitchInput 
                        label="Header vastzettten"
                        instruction="Zet de header vast aan de bovenkant van de pagina."
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        :options="options"
                        options-property="header_fixed" 
                        :open="true"
                    />

                    <ColorsInput
                        label="Menu achtergrond kleur"
                        instruction="Kies de achtergrond kleur van de header."
                        :colors="colors"
                        :options="options"
                        options-property="header_background_color"
                    />

                    <ColorsInput
                        label="Menu tekst kleur"
                        instruction="Kies de tekst kleur van de header."
                        :colors="colors"
                        :options="options"
                        options-property="header_text_color"
                    />

                    <!-- <SwitchInput label="Uitlijning slider tekst"
                         instruction="Kies waar de slider teksten worden uitgelijnd"
                         :items="[
                            { value: 'left', label: 'Links'},
                            { value: 'center', label: 'Midden'},
                            { value: 'right', label: 'Rechts'},
                         ]"
                         :options="options"
                        options-property="slider-text-alignment"
                    /> -->

                </div>

                <div slot="Design">

                    <CommonInputs :options="options"/>

                </div>
                
            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import ColorsInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/ColorsInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import getDatabaseColors from "@galaxy/modules/Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
        ColorsInput,
        Tabs,
    },

    data: function () {
        return {
            colors: null,
        }
    },

    mounted() {
        this.loadColors();
    },

    methods: {

        async loadColors() {
            // Grab database colors
            let databaseColors = (await getDatabaseColors()).data;

            // Initialize empty array
            this.colors = [
                'transparent',
                'white',
                'black',
            ];

            // Add colors from database to array
            $.each(databaseColors, (item, value) => {
                if (typeof value !== 'string') {
                    this.colors.push(...Object.values(value));
                } else {
                    this.colors.push(value);
                }
            })

            this.colors = _.uniq(this.colors);
        },

    },
}

</script>

<style lang="scss" scoped>

.canvas-blocks-sky-headerAlfa-BlockPanel {

}

</style>
